import { Flex, Button, Typography, Modal, Select } from "antd";
import { useDisclosure } from "@/shared/lib/hooks";
import { InputSearch } from "@shared/ui";
import { ConfigurableTable } from "../../../docstore-section-table/ui/configurable-table";
import { mockData, tableConfig } from "./model/config";
import "./modal-work-draw.scss";

export function ModalWorkDraw() {
  const {
    isOpen: isWorkDrawOpen,
    onOpen: onWorkDrawOpen,
    onClose: onWorkDrawClose,
  } = useDisclosure();

  return (
    <Flex vertical gap="8px">
      <Button
        color="default"
        variant="filled"
        style={{ width: "30%" }}
        onClick={onWorkDrawOpen}
      >
        Рабочий чертеж
      </Button>
      <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
        Выберите или загрузите чертёж из раздела &quot;Проектная
        документация&quot;
      </Typography.Text>

      <Modal
        title="Рабочий чертеж"
        open={isWorkDrawOpen}
        onCancel={onWorkDrawClose}
        footer={
          <Flex gap="small" justify="start">
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
            <Button onClick={onWorkDrawClose}>Отменить</Button>
          </Flex>
        }
        width="960px"
      >
        <Flex align="center" justify="space-between" gap="middle">
          <Flex gap="middle" style={{ width: "100%" }}>
            <InputSearch
              placeholder="Поиск по наименованию"
              className="inputSearch"
              style={{ width: "40%" }}
            />
            <Flex gap="4px" align="center" style={{ width: "50%" }}>
              <Typography.Text>Шифр</Typography.Text>
              <Select options={[]} style={{ width: "50%" }} />
            </Flex>
          </Flex>

          <Button color="default" variant="filled">
            Загрузить документ
          </Button>
        </Flex>

        <ConfigurableTable dataSource={mockData} config={tableConfig} />
      </Modal>
    </Flex>
  );
}
